import styled from 'styled-components/macro';

const AppWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
`;

export default AppWrapper;
